// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vant from 'vant'
import 'vant/lib/index.css';
import { ajax } from "./config/fetch";
Vue.use(Vant)
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { baseUrl } from './config/env';
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer) 
Vue.use(BaiduMap, {
    /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
    ak: 'XC4D0Hgvsp243FB55rnRMBVuBX6TWZxi'
  })
import BaiduMap from 'vue-baidu-map'
// import * as math from 'mathjs'     // 新版本需要这样引入 感谢评论区的指出

import * as math from 'mathjs/lib/browser/math'     // 新版本需要这样引入 感谢评论区的指出

Vue.prototype.$math = math
Vue.use(VueQuillEditor)
import axios from 'axios';

Vue.prototype.$axios = axios;

Vue.prototype.ajax = function(path, data, type,fnSuccess){
    if (type != "POST") {
        type = "GET";
    }
    var _data = data;
    var that = this
    ajax({
        url: baseUrl + path,
        data: data,
        type: type,
        contentType: 'application/json',
        dataType : 'json',
        //headers可以不用放里面的,你的ajax请求需要什么你就应该放到对应的位置
        headers: {
            // "programId":"manager"//此处放置请求到的用户token
        },
        success: function (res) {
            //可以console.log(res) 看下你的结果
            if (!fnSuccess) return false;
            if (res.orsuccess == '1') {
                fnSuccess(res);
        } else if( res.orsuccess == '-99' || res.orsuccess == '-98') {
                that.$message({
                    duration:2000,
                    message:'请重新登录'
                });
                that.$store.commit('login','false')
                that.$store.commit('logout','false')
                that.$router.push({ path: '/login'})
            } else if(res.orsuccess =='0'){

                that.$confirm(res.Msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        
                    }).catch(() => {
                            
                    });
            } else {
                fnSuccess(res);
            }
               
        },
        error: function (e) {
            that.$message({
                duration:2000,
                message:'错误'
              });
            // console.log('错误码:'+e.status+';'+'错误信息:'+e.statusText);
        },
        async : false,
    });
  }; 



// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

// Object.keys(custom).forEach(key => {
//     Vue.filter(key, custom[key])
// })

// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限 
            console.log(Boolean(localStorage.getItem("userInfo")))
            if ( Boolean(localStorage.getItem("userInfo")) || localStorage.getItem("userInfo") !='false' ) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (Boolean(localStorage.getItem("userInfo"))) { // 判断是否登录
                if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
                    next();
                } else {
                    /**
                     * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
                     */
                    next({
                        path: '/home/home'
                    })
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js